import {
  getUrl,
  getOptionalUrl,
} from "@surya-digital/leo-ts-types";

export interface ThemedImageDTO {
  lightImageURL: string;
  darkImageURL?: string | null;
}

export class ThemedImage {
  readonly isThemedImageThemedImage: boolean = true;

  readonly lightImageURL: URL;
  readonly darkImageURL: URL | null;


  constructor(
  lightImageURL: URL, 
  darkImageURL: URL | null = null
  ) {
    this.lightImageURL = lightImageURL;
    this.darkImageURL = darkImageURL;
  }

  static fromDTO(dto: ThemedImageDTO): ThemedImage {
    const lightImageURL = getUrl(dto, "lightImageURL", InvalidThemedImageLightImageUrlError);
    const darkImageURL = getOptionalUrl(dto, "darkImageURL", InvalidThemedImageDarkImageUrlError);
    return new ThemedImage(
      lightImageURL,
      darkImageURL
    );
  }

  toDTO(): ThemedImageDTO {
    const dto: ThemedImageDTO = {
        lightImageURL: this.lightImageURL.toString(),
    };
    if (this.darkImageURL !== undefined && this.darkImageURL !== null){
      dto.darkImageURL = this.darkImageURL.toString();
    }
    return dto;
  }
  }

ThemedImage.prototype.toString = function toString(): string {
  return `ThemedImage(lightImageURL='${this.lightImageURL}',darkImageURL='${this.darkImageURL}')`;
};

export class InvalidThemedImageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemedImageError";
  }
}
export class InvalidThemedImageLightImageUrlError extends InvalidThemedImageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemedImageLightImageUrlError";
  }
}

export class InvalidThemedImageDarkImageUrlError extends InvalidThemedImageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidThemedImageDarkImageUrlError";
  }
}
